import * as Sentry from '@sentry/react';
import { isReloadingForStaleChunk } from '@/components/errors/chunkReload';

// AL-2004: while the page is reloading onto a new build, what breaks on the
// way out is a side effect of cancelling the stale import, not a bug.
export function beforeSend(event: Sentry.ErrorEvent): Sentry.ErrorEvent | null {
  return isReloadingForStaleChunk() ? null : event;
}

export function initSentry() {
  if (import.meta.env.VITE_SENTRY_DSN) {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      environment: import.meta.env.MODE,
      // Enable performance monitoring
      tracesSampleRate: 1.0, // Adjust this value in production (1.0 = 100% of transactions for performance monitoring)
      // Enable session replay
      replaysSessionSampleRate: 0.1, // 10% of sessions
      replaysOnErrorSampleRate: 1.0, // 100% of error sessions
      // This sets the sample rate to be 10%. You may want this to be 100% while
      // in development and sample at a lower rate in production
      profilesSampleRate: 1.0, // 100% of transactions are profiled
      // Configure beforeSend to filter or modify events
      beforeSend,
      // Enable tracing
      integrations: [
        // Add browser tracing integration if needed
        // new Sentry.browserTracingIntegration(),
        // Add replay integration if needed
        // new Sentry.replayIntegration(),
      ],
    });
  }
}

export { Sentry };
